// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Chip } from 'ui';
import ColorConstants from 'constants/ColorConstants'
import { CODE_COLORS, CODE_TAG_BACKGROUND_COLORS } from 'constants/CodeColorConstants';

function CodeX({ codeColor, onClick }) {

  const HOVER_STYLE = {
    color: ColorConstants.DARK_GREY,
    backgroundColor: CODE_TAG_BACKGROUND_COLORS[codeColor],
    border: `1px solid ${CODE_COLORS[codeColor]}`,
    fontWeight:"normal",
    cursor:"pointer",
    transition: 'all 0.3s ease-in-out'
  };

   
  return <Chip
    className='code-x'
    style={HOVER_STYLE}
    onClick={onClick}>
      x
  </Chip>
}

export default CodeX;
